import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

const Fabrication = (props) => {
  const {
    quantity,
    unitPrice,
    leadTime,
    subTotal,
    selected,
    cleanUp,
  } = props;

  const [open, setOpen] = useState(false);

  if (!selected) return null;

  const onDelete = () => {
    cleanUp();
    setOpen(false);
  };

  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section fabrication">
      <div className="title">
        {Spree.translations.fabrication_title}
        <button type="button" onClick={onDelete} className="btn btn-link float-right btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">{subTotal !== undefined ? `$${subTotal.toFixed(2)}` : null}</div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {open ? Spree.translations.view_less : Spree.translations.view_more}
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>
                  {Spree.translations.lead_time}
                  :
                </strong>
                &nbsp;
                {leadTime}
              </div>
              <div className="detail">
                <strong>
                  {Spree.translations.quantity}
                  :
                </strong>
                &nbsp;
                {quantity}
              </div>
              <div className="detail">
                <strong>
                  {Spree.translations.unit_price}
                  :
                </strong>
                &nbsp;
                {unitPrice !== undefined ? `$${unitPrice.toFixed(2)}` : null}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

Fabrication.defaultProps = {
  quantity: 0,
  unitPrice: 0,
  leadTime: 0,
  subTotal: 0,
  selected: false,
};

Fabrication.propTypes = {
  quantity: PropTypes.number,
  unitPrice: PropTypes.number,
  leadTime: PropTypes.number,
  subTotal: PropTypes.number,
  selected: PropTypes.bool,
  cleanUp: PropTypes.func.isRequired,
};

export default Fabrication;
